/* eslint-disable default-case */
/* eslint-disable import/no-anonymous-default-export */
import{
    GET_READ,
    GET_READ_SUCCESS,
    GET_READ_FAIL,
    GET_READ_RESET
} from '../action/getReadAction'

import{ api_err_msg} from '../strings.json'

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}
export default function(state = initialState, action){
    switch(action.type){
        case GET_READ :
            return{ 
                ...state,
                apiState: 'loading'
            }
        case GET_READ_FAIL : 
            return{ 
                ...state,
                apiState: 'error',
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_READ_SUCCESS : 
            return{ 
                ...state,
                apiState: 'success',
                data:action.response.data.data.result.text,
            }
        case GET_READ_RESET:
            return initialState
        default:
            return state
    }
}